import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import PermissionSession from './permissions/PermissionSession';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store';
import { setupAxiosInterceptors } from './utils/axiosConfig';

// Configure global axios interceptors (auth headers, archive mode, etc.)
setupAxiosInterceptors();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
  <React.StrictMode>
    <PermissionSession><App /></PermissionSession>
  </React.StrictMode>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
